const init = () => {
  if (import.meta.env.MODE === 'production') {
    return window.location.origin
  } else if (import.meta.env.MODE === 'development') {
    return import.meta.env.VITE_SERVER_URL
  }
}

export default init()
